module.exports = __webpack_public_path__ + "media/images/svg/twitter-757bc7bed8b0c68486aeefbb86d6be25.svg";